import { create } from 'zustand';

export type Theme = 'light' | 'dark' | 'system';
const KEY = 'dovo.theme';

function saved(): Theme {
  try {
    const value = localStorage.getItem(KEY);
    if (value === 'light' || value === 'dark' || value === 'system') return value;
  } catch {
    // Storage can be blocked; the light theme it is.
  }
  return 'light';
}

/** Puts the `dark` class on <html> when the chosen theme (or the system) is dark. */
export function applyTheme(theme: Theme) {
  const dark = theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.classList.toggle('dark', dark);
}

export const useTheme = create<{ theme: Theme; setTheme: (theme: Theme) => void }>((set) => ({
  theme: saved(),
  setTheme: (theme) => {
    try {
      localStorage.setItem(KEY, theme);
    } catch {
      // Applied for this visit only.
    }
    applyTheme(theme);
    set({ theme });
  },
}));
